import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { Input, Select } from '~/components/Form';
import { ADM } from '~/constants/perfil';

import * as S from './styles';

export default function Dados() {
  const [textarea, setTextArea] = useState(true);

  const { glousuariotipo } = useSelector((state) => state.user.profile);

  const optionsAI = useMemo(
    () => [
      { value: 'A', label: 'Ativo' },
      { value: 'I', label: 'Inativo' },
    ],
    []
  );

  const optionsSN = useMemo(
    () => [
      { value: 'S', label: 'Sim' },
      { value: 'N', label: 'Não' },
    ],
    []
  );

  return (
    <S.Container>
      <Input disabled name="unid_codigo" label="Unidade" />

      <Input disabled name="unid_nome" label="Nome" />

      <Input disabled name="orga_nome" label="Órgão" />

      <Select disabled name="unid_status" label="Status" options={optionsAI} />

      {glousuariotipo === ADM && (
        <>
          <Select
            name="unid_bloqueio_inadimplencia"
            label="Bloqueio Por Contrato"
            options={optionsSN}
            getValue={(value) => setTextArea(value !== 'S')}
          />

          <Input
            multiline
            name="unid_bloqueio_inadimplencia_observacao"
            label="Observação Bloqueio Por Contrato"
            rows={4}
            disabled={textarea}
          />
        </>
      )}
    </S.Container>
  );
}
